import { gql } from '@apollo/client'

export const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: LowercaseString!) {
    requestPasswordReset(email: $email) {
      email
    }
  }
`
